import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { themeOptions } from 'assets/styles/theme';

export const Label = styled(Typography)`
  color: ${themeOptions.palette.grey[500]};
  font-size: 12px;
  margin-bottom: 4px;
`;
